import { render, staticRenderFns } from "./communication-form.vue?vue&type=template&id=2b6ef027&scoped=true"
import script from "./communication-form.vue?vue&type=script&lang=js"
export * from "./communication-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ef027",
  null
  
)

export default component.exports